module.exports = __webpack_public_path__ + "sj.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/1x1/sj.svg
// module id = 1059
// module chunks = 0